import { defaultAssetPathResolutionPredicate } from "./path-resolution-interceptor";
import { ServiceDeskConfig } from "../../Startup/serviceDeskConfig";

/** This service is responsible for mapping relative paths to CDN located paths at runtime. */
export interface PathResolutionService {
  /** Resolves an input path, with an optional predicate to test ONLY the path portion (doing this requires URI parsing) to see if the path is a
   *  candidate for path resolution. This works by finding "beacon"s in the path portion of the URI. */
  /** @param path The path to map to an asset path. Path can be relative or absolute. */
  /** @param pathPredicate Path that evaluates just the path part of the uri. If URI submitted is: "http://www.thing.com/stuff/something?foo=bar", the path will be "/stuff/something". */
  resolvePath(path: string, pathPredicate?: (path: string) => boolean): string;
}

// This needs to be available at config time for the interceptor and any other novel uses.
export class AssetPathResolutionService implements PathResolutionService {
  private anchor: HTMLAnchorElement;
  // @ngInject
  constructor(private sdConfig: ServiceDeskConfig) {
    this.anchor = <HTMLAnchorElement>angular.element("<a/>")[0];
  }

  public resolvePath(path: string, pathPredicate?: (path: string) => boolean): string {
    pathPredicate = pathPredicate || defaultAssetPathResolutionPredicate;
    // This check is a short circuit to make sure we're using absolute path beacons. This SHOULD prevent normal prod usage.
    if (Object.keys(this.sdConfig.absolutePathBeacons).length > 0) {
      this.anchor.href = path;
      if (pathPredicate(this.anchor.pathname.toLowerCase())) {
        let splitPath = this.anchor.pathname.split("/");
        let potentialBeacon = splitPath.length > 0 && splitPath[1];
        let matchingBeacon = Object.keys(this.sdConfig.absolutePathBeacons).find(
          (x) => x.toLowerCase() == potentialBeacon.toLowerCase()
        );
        if (matchingBeacon) {
          let potentialBeaconIndex = path.toLocaleLowerCase().indexOf(potentialBeacon.toLowerCase());
          if (potentialBeaconIndex >= 0) {
            return `${this.sdConfig.absolutePathBeacons[matchingBeacon]}${path.substring(
              potentialBeaconIndex + potentialBeacon.length
            )}`;
          }
        }
      }
    }

    return path;
  }
}
